export default "__VITE_ASSET__LOiXcNmb__"